import Api from './Api';

export default class LinkedinApi extends Api {
  constructor(config = {}) {
    super(config);
  }

  getFeedPosts(params = {}) {
    return this.doGet({ path: '/linkedin-gateway/feed/posts', params });
  }

  dismissPost(id, status) {
    return this.doPut(
      { path: `/linkedin-gateway/feed/posts/${id}` },
      { status }
    );
  }
}
